import { render, staticRenderFns } from "./chatRoom.vue?vue&type=template&id=389530e8&scoped=true"
import script from "./chatRoom.vue?vue&type=script&lang=js"
export * from "./chatRoom.vue?vue&type=script&lang=js"
import style0 from "./chatRoom.vue?vue&type=style&index=0&id=389530e8&prod&scoped=true&lang=scss"
import style1 from "./chatRoom.vue?vue&type=style&index=1&id=389530e8&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "389530e8",
  null
  
)

export default component.exports